const Global = {
  environments: {
    DEVELOPMENT: 'development',
    STAGING: 'staging',
    DEMO: 'demo',
    PRODUCTION: 'production',
    QA: 'qa',
  },
  localStorageKeys: {
    SESSION_EXPIRATION: 'advicepay-session-expiration',
  }
}

export default Global;
